import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface LinkCellRendererParams extends ICellRendererParams {
    linkFunction: (row: unknown) => void;
}

/**
 * A plain cell whose formatted value is rendered as a link that calls the
 * column's `linkFunction` with the original row, as static-table does.
 */
@Component({
    selector: 'link-cell-renderer',
    template: `
        <a (click)="params.linkFunction(params.data?.data)">{{
            params.value
        }}</a>
    `
})
export class LinkCellRenderer implements ICellRendererAngularComp {
    params: LinkCellRendererParams;

    agInit(params: LinkCellRendererParams) {
        this.params = params;
    }

    refresh(params: LinkCellRendererParams) {
        this.params = params;
        return true;
    }
}
